import { render, staticRenderFns } from "./weeklySchedule.vue?vue&type=template&id=8026b86e"
import script from "./weeklySchedule.vue?vue&type=script&lang=js"
export * from "./weeklySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports